export default function () {
	if (window.addEventListener) {
		window.addEventListener(
			'load',
			() => {
				if (location.hash && location.hash !== '#') {
					const anchorLocation = decodeURIComponent(location.hash);
					const anchorElement = document.querySelector(anchorLocation);

					if (jQuery('.js-expandable-content--auto-expand').length > 0) {
						let autoExpands = Array(jQuery('.js-expandable-content--auto-expand'));

						autoExpands.forEach((expandableTrigger) => {
							jQuery(expandableTrigger).trigger('click');
						});
					}

					setTimeout(() => {
						if (anchorElement) {
							if (jQuery(anchorElement).hasClass('accordion')) {
								jQuery(anchorElement).find('.js-accordion--toggle').trigger('click');
							}

							if (jQuery(anchorElement).hasClass('expandable-content')) {
								let triggerElement = jQuery(anchorElement).find('.js-expandable-content--toggle');

								if (!triggerElement.hasClass('js-expandable-content--auto-expand')) triggerElement.trigger('click');
							}

							setTimeout(() => {
								anchorElement.scrollIntoView({ behavior: 'smooth' });
							}, 300);
						}
					}, 300);
				}
			},
			false
		);
	}
}
